import React from 'react';
import { useSelector } from 'react-redux';
import selectors from 'state/selectors';
import { modalActionType } from 'utils/constants';
// modals
import DeleteConfirmationModal from './Modals/DeleteConfirmation';
import RetryErrors from './Modals/RetryErrors';
import { LoadingErrors } from './Modals/Loader';

const ModalsSwitcher = () => {
  const action = useSelector(selectors.modal.getActionType);

  switch (action) {
    case modalActionType.normalizer.LOADING_ERROR:
      return <LoadingErrors />;
    case modalActionType.normalizer.DELETE_CONFIRMATION:
      return <DeleteConfirmationModal />;
    case modalActionType.normalizer.RETRY_ERRORS:
        return <RetryErrors />;
    default:
      return null;
  }
};

export default ModalsSwitcher;
